import { EPIC_FIELDS } from './_const';
/**
 * helper function to extract a specific property (key and value) from an object
 * @param {string} propName name of property you'd like to get
 * @param {object} primarySource additional object to look in first.  Default will be EPIC_FIELDS.  Used primarily to repopulate in Mod requests.
 * @example
 * const EPIC_FIELDS = {
 *   field1: {
 *     defaultValue: 'foo',
 *     validationSchema: Yup.string()
 *   },
 *   field2: {
 *     defaultValue: 100,
 *     validationSchema: Yup.number()
 *   }
 * }
 * extractData('defaultValue);
 * //returns
 * //{
 * //  field1: {
 * //    defaultValue: 'foo',
 * //  },
 * //  field2: {
 * //    defaultValue: 100,
 * //  }
 * //}
 *
 * @returns an object containing only the property you requested
 */
export const extractValues = (propName, primarySource = null) => {
	const obj = {};
	Object.entries(EPIC_FIELDS).forEach(([key, value]) => {
		if (!(key in obj)) {
			obj[key] =
				primarySource && key in primarySource
					? primarySource[key]
					: value[propName] ?? '';
		}
	});
	return obj;
};

export const generateDepartmentDisplayValue = deptObj => {
	if ('departmentId' in deptObj && 'departmentName' in deptObj) {
		return `${deptObj.departmentId} - ${deptObj.departmentName}`;
	}
	return deptObj;
};
